import { INVOICING_FREQUENCIES } from '@/lib/constants/invoicingFrequencies'

let getInvoicingFrequencyLabel = (invoiceFrequencyId) => {
  return INVOICING_FREQUENCIES[invoiceFrequencyId]
}

export default getInvoicingFrequencyLabel
